module.exports = __webpack_public_path__ + "static/benefits-0c2c61bf1e9ef09f71cc62c74b101c5e.webp";